"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spotify = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const js_cookie_1 = __importDefault(require("js-cookie"));
class Spotify {
    constructor(element) {
        this.element = null;
        this.widget = null;
        this.consent = null;
        this.iframe = null;
        this.element = element;
        if (!element || element.length === 0)
            return;
        this.widget = (0, cash_dom_1.default)('.spotify-widget', element);
        this.consent = (0, cash_dom_1.default)('.spotify-consent', element);
        this.iframe = (0, cash_dom_1.default)('iframe', this.widget);
        if (!this.iframe || this.iframe.length === 0)
            return;
        this._init();
    }
    _init() {
        if (this._isConsented()) {
            this._showWidget();
        }
        else {
            this.consent.show();
            (0, cash_dom_1.default)('.accept', this.consent).on('click', () => {
                js_cookie_1.default.set('external-spotify', new Date().toJSON(), { expires: 120 });
                this.consent.hide();
                this._showWidget();
            });
        }
    }
    _isConsented() {
        const cookie = js_cookie_1.default.get('external-spotify');
        return !!cookie && cookie.length >= 3;
    }
    _showWidget() {
        const src = this.iframe.attr('data-src');
        if (src) {
            this.iframe.attr('src', src);
        }
        this.widget.show();
    }
}
exports.Spotify = Spotify;
